import { Row, Col, Card, Collapse } from 'antd';
import {
  NASTRING,
  TRANSACTION_STRING,
} from '../../../constants/StringConstants';
import {
  convertCentsIntoDollar,
  formatDate,
} from '../../../helpers/genericHelper';
import CustomText from '../../CustomText';
import LoaderComponent from '../../Loader';

const { Panel } = Collapse;

function DeclinedTransactionsComponent({ declinedTransactions = [] }) {
  return (
    <>
      {(declinedTransactions && declinedTransactions.length > 0) ?
        declinedTransactions.map((data) => (
          <Card
            bordered={false}
            hoverable={true}
            className="criclebox tablespace mb-16"
          >
            <Row
              className="save-build-box-container"
              gutter={[30, 30]}
              justify="space-between"
            >
              <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                <h4>ID</h4>
                <CustomText dataSet={data} property1={'id'} />
              </Col>
              <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                <h4>Date (UTC)</h4>
                <CustomText
                  dataSet={data}
                  property1={'createTs'}
                  formatter={(val) => formatDate(val, true)}
                />
              </Col>
              <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                <h4>Merchant</h4>
                <CustomText dataSet={data} property1={'merchantName'} />
              </Col>

              <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                <h4>Declined Reason</h4>
                <CustomText dataSet={data} property1={'declinedReason'} />
              </Col>

              <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                <h4>Amount</h4>
                <CustomText
                  dataSet={data}
                  property1={'authorizationAmount'}
                  formatter={convertCentsIntoDollar}
                />
              </Col>
            </Row>
          </Card>
        )) : (
          <Row className="no-data-card">No Transaction(s) Found</Row>
        )}
    </>
  );
}

export default DeclinedTransactionsComponent;
